import { Stack } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "@/i18n/client";
import Input from "@/components/Input";
import { IMaskInput } from "react-imask";
import { Trans } from "react-i18next";
import Link from "@/components/Link";
import { InputTooltip } from "@/components/InputTooltip";
import { NumberInput } from "@/components/Input/NumberInput";
import { CadastralTerritory } from "@/screens/common/Address/CadastralTerritory";
import { SupplyPointAddressFormValues } from "@/screens/SupplyPoint/SupplyPointAddress/form";

interface ParcelInfoProps {
  form: UseFormReturnType<SupplyPointAddressFormValues>;
}

export const ParcelInfo = ({ form }: ParcelInfoProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);

  return (
    <Stack gap={24}>
      <Input
        label={t("supplyPoint:supplyPointAddress.zip")}
        component={IMaskInput}
        mask="000 00"
        onAccept={value => form.setFieldValue("address.zip", value.split(" ").join(""))}
        {...form.getInputProps("address.zip")}
        value={form.values.address.zip}
        onChange={() => null}
        inputMode="numeric"
      />
      <CadastralTerritory
        cadastralTerritory={form.values.address.cadastralTerritory}
        label={t("supplyPoint:supplyPointAddress.cadastralTerritory")}
        onSubmit={selectedTerritory => {
          if (!selectedTerritory) {
            form.setFieldValue("address.cadastralTerritoryCode", null);
            return;
          }
          form.setFieldValue("address.cadastralTerritory", selectedTerritory.name);
          form.setFieldValue("address.cadastralTerritoryCode", selectedTerritory.code);
        }}
        helperText={
          <Trans
            t={t}
            i18nKey="hints:supplyPoint.cadastralTerritory"
            components={{
              linkCadastralOffice: <Link href="https://nahlizenidokn.cuzk.cz/" key="cadastralOfficeLink" />,
            }}
          />
        }
        cadastralTerritoryInputProps={form.getInputProps("address.cadastralTerritory")}
      />
      <InputTooltip
        tooltipProps={{
          label: t("hints:supplyPoint.parcelNumberParcelNumber"),
        }}>
        <NumberInput
          label={t("supplyPointAddress.parcelNumber.label")}
          {...form.getInputProps("address.parcelNumber")}
          maxLength={5}
        />
      </InputTooltip>
      <InputTooltip
        tooltipProps={{
          label: t("hints:supplyPoint.parcelNumberParcelPart"),
        }}>
        <NumberInput
          label={t("supplyPointAddress.parcelPart.label")}
          {...form.getInputProps("address.parcelPart")}
          maxLength={3}
        />
      </InputTooltip>
    </Stack>
  );
};
